import { Empty, List } from "antd";
import DataObjectConsentListItem from "components/atoms/DataObjectConsentListItem";

const DataObjectConsentList = ({ consentList }) => {
    return consentList && consentList.length > 0 ? (
        <List itemLayout="horizontal" dataSource={consentList} renderItem={(item) => <DataObjectConsentListItem consentItem={item}></DataObjectConsentListItem>} />
    ) : (
        <Empty description="No consent exist."></Empty>
    );
};

export default DataObjectConsentList;
